import { render } from "./DocumentInfoOverview.vue?vue&type=template&id=5f863ba2&scoped=true&ts=true"
import script from "./DocumentInfoOverview.vue?vue&type=script&lang=ts"
export * from "./DocumentInfoOverview.vue?vue&type=script&lang=ts"

import "./DocumentInfoOverview.vue?vue&type=style&index=0&id=5f863ba2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f863ba2"]])

export default __exports__